//const merchantOneString = localStorage.getItem('merchantOne')
//const merchantOne = merchantOneString ? JSON.parse(merchantOneString) : ''
const DefaultSettings = Object.freeze({
    perPage: 10,
    pagination: [{ value: '10', label: '10' }, { value: '25', label: '25' }, { value: '50', label: '50' }, { value: '100', label: '100' }, { value: '250', label: '250' }, { value: '500', label: '500' }, { value: '1000', label: '1000' }, { value: '1500', label: '1500' }]
    // URL: 'https://secure.merchantonegateway.com/token/Collect.js',
    // maritimeEnterpriseKey: merchantOne.maritimeEnterpriseKey,
    // maritimeOperationsKey: merchantOne.maritimeOperationsKey
})

export default DefaultSettings